module.exports = __webpack_public_path__ + "img/2_108.682de3c6.png";